import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Play = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 15.3914L15.0288 11.6234L9 8.35784V15.3914ZM7 6.67889V17.1957C7 17.9811 7.86395 18.46 8.53 18.0437L17.5444 12.4097C18.1942 12.0035 18.1645 11.0474 17.4907 10.6824L8.47628 5.7996C7.80998 5.43869 7 5.92112 7 6.67889Z"
      fill="currentColor"
    />
  </Icon>
));

export default Play;
